import styled from 'styled-components/macro'

import { theme, fluidSystem, mediaS, mediaM, mediaShort, NavButton } from 'styled'
import oywUnderline from './../../assets/line-under.svg'

export const Root = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  color: ${theme.colors.white};
  opacity: ${({ ready }) => (ready ? 1 : 0)};
  transition: opacity 2s 1s;
  z-index: 0;

  ${mediaM`
    overflow: initial;
    overflow-y: auto;
  `};
`

export const Content = styled.div`
  ${fluidSystem};
  width: 100%;

  ${mediaM`
    height: 100%;
  `};

  ${mediaShort`
    height: 100%;
    padding: 40px;
  `};
`

export const ContentInner = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  ${mediaM`
    height: 100%;
    align-items: flex-start;
    padding-top: 40px;
  `};

  ${mediaShort`
    padding-top: 60px;
  `};
`

export const Body = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 40px;

  ${mediaM`
    flex: 0 999 100%;
  `};
`
export const Header = styled.h1`
  ${fluidSystem};
  text-align: center;

  > .OYW {
    position: relative;
    display: inline-block;

    &:after {
      content: '';
      position: absolute;
      bottom: -10px;
      left: 0;
      width: 100%;
      padding-bottom: 8.2%;
      background-image: url(${oywUnderline});
      background-repeat: no-repeat;
      background-size: contain;
      transform: translate(0, 100%);
    }
  }
  ${mediaShort`
    padding-bottom: 60px;

    > * {
      font-size: 36px;
    }

  `};

  ${mediaM`
    text-align: left;
    `};
`

export const IntroText = styled.p`
  ${fluidSystem};
  color: ${theme.colors.body};
  margin-top: 100vw;

  ${mediaS`
      margin-top: 95vw;
  `};

  ${mediaM`
      margin-top: 0;
      color: inherit;
      max-width: 400px;
  `};

  ${mediaShort`
      line-height: 1.2;
      font-size: 16px;
  `};
`
export const FrostBox = styled.div`
  ${fluidSystem};
  color: ${theme.colors.body};
  text-align: center;
  border-top: 1px solid rgba(221, 221, 221, 0.5);

  &:after {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(30px);
    z-index: -1;

    ${mediaM`
      content: '';
      `};
  }

  ${mediaM`
    position: absolute;
    bottom: 24px;
    right: 24px;
    max-width: 320px;
    color: inherit;
    border-top: none;
    z-index: 0;
  `}
`

export const Link = styled.a`
  ${fluidSystem};
  display: inline-block;
  text-transform: uppercase;
  padding-bottom: 2px;
  border-bottom: 1px solid ${theme.colors.white};

  > div {
    transition: transform 0.2s;
  }

  &:hover {
    div {
      transform: translate(0, -4px);
    }
  }
`

export const IntroButton = styled(NavButton)`
  background-color: ${({ secondary }) =>
    secondary ? theme.colors.secondary : theme.colors.primary};
  border-color: ${({ secondary }) => (secondary ? theme.colors.secondary : theme.colors.primary)};

  ${mediaM`
    background-color: transparent;
    border-color: ${theme.colors.white};
  `};
`

export const Copyright = styled.div`
  ${fluidSystem};
  display: none;

  ${mediaM`
    display: block;
  `};

  ${mediaShort`
    margin-top: 40px;
  `};
`

export const HeaderBg = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 56px;
  background-color: ${theme.colors.primary};
  opacity: ${({ show }) => (show ? 1 : 0)};
  transition: opacity 0.3s;

  ${mediaM`
    display: none;
  `};
`
